import { ParticipantToReference, SignerToReference } from '@modusign/react-signing/types';

export function checkIsInOrder(participants: ParticipantToReference[] | undefined) {
  return (
    participants
      ?.filter((p): p is SignerToReference => p.type === 'SIGNER')
      .some((p) => p.order !== 1) ?? false
  );
}
